import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FirebaseService } from '../services/firebase.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  uname:string ='';
  pass:string = '';

  constructor(private r:Router, private fs: FirebaseService) { }

  ngOnInit(): void {
  }

  onSubmit(){
    if(this.uname == 'admin' && this.pass=='purenetadmin'){ this.fs.adminLin(); this.r.navigateByUrl('adminbackend'); }
    else alert("Invalid username or password!");
  }

}
